import { type AlertBannerInteraction, BannerType } from '@generated/graphql';

const BANNER_TYPE_ORDER: Record<BannerType, number> = {
  [BannerType.Urgent]: 0,
  [BannerType.Warning]: 1,
  [BannerType.Success]: 2,
  [BannerType.Info]: 3,
};

/**
 * Sort banners by type, Urgent > Warning > Success > Info
 * If multiple banners exist for a type, order them by createdAt (created first to most recent).
 *
 * @param bannerInteractions
 * @returns sortedBannerInteractions
 */
export const sortBannerInteractionsByType = (
  bannerInteractions: AlertBannerInteraction[],
): AlertBannerInteraction[] => {
  return [...bannerInteractions].sort((a, b) => {
    // biome-ignore lint/style/noNonNullAssertion: bannerType required for published banners
    const typeA = a.alertBanner.bannerType!;
    // biome-ignore lint/style/noNonNullAssertion: bannerType required for published banners
    const typeB = b.alertBanner.bannerType!;
    const orderA = BANNER_TYPE_ORDER[typeA] ?? 4;
    const orderB = BANNER_TYPE_ORDER[typeB] ?? 4;

    if (orderA !== orderB) return orderA - orderB;

    const createdA = a.alertBanner.createdAt;
    const createdB = b.alertBanner.createdAt;

    return createdA.localeCompare(createdB);
  });
};
